import React from "react"

import { IoLogoFacebook, IoLogoInstagram} from "react-icons/io"
export default [
  {
    icon: <IoLogoFacebook />,
    url: "https://www.facebook.com/pages/category/Jewelry-Watches/Zlatara-Alisa-1678455885784989/",
  },
  {
    icon: <IoLogoInstagram />,
    url: "https://www.instagram.com/zlatara_alisa/?hl=en",
  }
]